










import Vue from 'vue'
import {mapState} from 'vuex'
import AdminListaSegnalazioni from '../components/report/admin/AdminListaSegnalazioni.vue'
import AdminSegnalazioneSelezionata from '../components/report/admin/AdminSegnalazioneSelezionata.vue'
import Azioni from '../components/report/Azioni.vue'

export default Vue.extend({
    metaInfo: {
        title: 'Report Admin'
    },
    components: {
        AdminListaSegnalazioni, AdminSegnalazioneSelezionata, Azioni
    },
    computed: {
        ...mapState('reportAdmin', ['segnalazioneSelezionata'])
    }
})
